// extracted by mini-css-extract-plugin
export default {"button":"button_button__T5nVK","none":"button_none__xSeZm"};